import { push } from 'redux-first-history';

import {
  doSmsEnrollVerifyStart,
  doStartVerifyImprivataId,
  startLoading,
  setServerState,
  doLogout,
  doSecondFactorFailure,
  setTempCodeToManual,
  doStartVerifyNumberForImprivataId,
  doStartInitiateIdv,
  doStartWaitIdvResult,
  doLoginFailure
} from './shared';
import { decideNextStep } from './decideNextStep';
import * as types from '../constants/cidraActions';
import {
  doInitiateIdv, doResendSms, doVerifyIcpFace
} from './authentication';
import {
  ChooseModalityProtocols,
  GetMessageProtocols
} from '../constants/clientProtocols';
import { storeAuthenticationState } from './resumeAuthSession';
import { getModalityOrder, SECONDFACTORONLY_WORKFLOW } from '../constants/workflowConstants';

export function chooseModality(serverState, isEnrollment, manuallyProceedToTempCode) {
  return function(dispatch, getState) {
    const {
      ModalIdOutOfBand,
      ModalImprivataId,
      ModalIdToken,
      ModalIdPassword,
      ModalEmailOtp,
      ModalImprivataPin,
      ModalAllowEligibility,
      ModalOutOfBandEnrollState,
      ModalOutOfBandAuthState,
      ModalOutOfBandAuthWaitManual,
      ModalEnrollmentState,
      ModalAuthState,
      ModalAuthStateTypeRequireManual,
      ModalTokenAuthState,
      ModalTokenAuthStateTypeIdTokenChallenge,
      ModalPasswordAuthState,
      ModalPasswordAuthStateTypeExpired,
      ModalPasswordAuthStateTypePassChangeOnLogin,
      ModalAuthStateTypeNumberMatching,
      ModalFace,
      ModalIdIdv,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeIdvInitiated,
      ModalIdvAuthStateTypeIdvWaitForResult,
    } = ChooseModalityProtocols;

    if (manuallyProceedToTempCode && serverState.temporaryCodeAllowed &&
      serverState.temporaryCodeAvailable && isStrongFactor(serverState.currentModality) ) {
      dispatch(captureAvailableModalities(serverState, manuallyProceedToTempCode) );
      dispatch(captureAuthenticatedModalities(serverState, manuallyProceedToTempCode) );
      dispatch(doInputTempCode() );
      dispatch(push('/tempcode') );
    }
    else {
      dispatch(captureAvailableModalities(serverState, manuallyProceedToTempCode) );
      dispatch(captureAuthenticatedModalities(serverState, manuallyProceedToTempCode) );
      switch (serverState.currentModality) {
      case ModalIdOutOfBand.asString:
        if (isEnrollment) {
          const outOfBandState = ModalOutOfBandEnrollState.getValue(serverState.modalities.optionalOutOfBandEnrollmentState);
          const canSkipEnrollment = ModalAllowEligibility.asString ===
              outOfBandState.enrollmentEligibility;
          const canChangeEnrollmentModality = isAnotherEnrollmentModalityAvailable(serverState);

          let phoneNumber;
          if (outOfBandState.phoneNumber) {
            phoneNumber = outOfBandState.phoneNumber;
          }

          dispatch(push('/enrollsms') );
          if (phoneNumber) {
            dispatch(doSmsEnrollVerifyStart(phoneNumber) );
          }
          else {
            dispatch(doInputSmsEnroll(canSkipEnrollment, canChangeEnrollmentModality) );
          }
        }
        else {
          let lastFourDigits;
          const outOfBandState = ModalOutOfBandAuthState.getValue(serverState.modalities.optionalOutOfBandAuthenticationState);
          if (outOfBandState !== undefined) {
            switch (outOfBandState.outOfBandAuthenticationStateType) {
            case ModalOutOfBandAuthWaitManual:
              lastFourDigits = outOfBandState.tokens[0].phoneNumber;
              break;
            default:
              break;
            }
          }
          dispatch(doInputSms(lastFourDigits) );
          dispatch(push('/sms') );
        }
        break;
      case ModalImprivataId.asString:
        if (isEnrollment) {
          const iidEnrollmentState = ModalEnrollmentState.getValue(serverState.modalities.optionalImprivataIdEnrollmentState);
          const canSkipEnrollment = ModalAllowEligibility.asString === iidEnrollmentState.enrollmentEligibility;
          const canChangeEnrollmentModality = isAnotherEnrollmentModalityAvailable(serverState);
          dispatch(push('/enrollimprivataid') );
          dispatch(doInputIIDEnroll(canSkipEnrollment, canChangeEnrollmentModality) );
        }
        else {
          if (serverState.modalities.optionalImprivataIdAuthenticationState !== undefined) {
            const iidAuthState = ModalAuthState.getValue(serverState.modalities.optionalImprivataIdAuthenticationState);

            if (ModalAuthStateTypeRequireManual === iidAuthState.imprivataIdAuthenticationStateType) {
              dispatch(doInputImprivataIdManual(iidAuthState.deviceList) );
              dispatch(push('/iid-manual') );
            }
            else if (ModalAuthStateTypeNumberMatching === iidAuthState.imprivataIdAuthenticationStateType) {
              dispatch(doStartVerifyNumberForImprivataId(iidAuthState.authNumber, iidAuthState.deviceList) );
              dispatch(push('/iid') );
            }
            else {
              dispatch(doStartVerifyImprivataId(iidAuthState.deviceList) );
              dispatch(push('/iid') );
            }
          }
        }
        break;
      case ModalIdToken.asString:
        let challengeText;
        if (serverState.modalities.optionalIdTokenAuthenticationState !== undefined) {
          const idTokenData = ModalTokenAuthState.getValue(serverState.modalities.optionalIdTokenAuthenticationState);
          switch (idTokenData.idTokenAuthenticationStateType) {
          case ModalTokenAuthStateTypeIdTokenChallenge:
            challengeText = idTokenData.idTokenChallenge;
            break;
          default:
            break;
          }
        }
        dispatch(doInputOtp(challengeText) );
        dispatch(push('/otp') );
        break;
      case ModalIdPassword.asString:
        const passwordState = ModalPasswordAuthState.getValue(serverState.modalities.optionalPasswordAuthenticationState);
        if ([ModalPasswordAuthStateTypeExpired, ModalPasswordAuthStateTypePassChangeOnLogin,]
          .includes(passwordState.passwordAuthenticationStateType) ) {
          dispatch(doStartChangePassword() );
          dispatch(push('/password-reset') );
        }
        else {
          dispatch(doInputPassword() );
          dispatch(push('/password') );
        }
        break;
      case ModalEmailOtp.asString:
        dispatch(doInputEmail() );
        dispatch(push('/email') );
        break;
      case ModalImprivataPin.asString:
        dispatch(doInputPin() );
        dispatch(push('/pin') );
        break;
      case ModalFace.asString:
        if (getState().login.isCameraPresent === false) {
          // The device has no camera, so never route to the face screen again.
          // Switch to another available modality, let the user choose, or log out.
          dispatch(dispatchFallbackDecision(
            getFallbackModalityDecision(getState().login.availableModalities || []) ) );
        }
        else {
          dispatch(doIcpFaceVerification(serverState.authContext.icpDomainSuffix, serverState.authContext.icpTenantId) );
          dispatch(push('/face?showVideo=true&contextType=idp-authn&resourceType=impr-eam-endpoint&icpApiDomainSuffix='
            + serverState.authContext.icpDomainSuffix) );
        }
        break;
      case ModalIdIdv.asString:
        const idvAuthState = ModalIdvAuthState.getValue(serverState.modalities.optionalIdvAuthenticationState);
        if (idvAuthState !== undefined) {
          switch (idvAuthState.idvAuthenticationStateType) {
          case ModalIdvAuthStateTypeIdvInitiated:
            dispatch(doStartInitiateIdv() );
            dispatch(storeAuthenticationState(serverState.authContext.stateToken) );
            window.location.href = idvAuthState.flowUrl;
            break;
          case ModalIdvAuthStateTypeIdvWaitForResult:
            dispatch(doStartWaitIdvResult() );
            dispatch(push('/idv') );
            break;
          default:
            dispatch(doStartInitiateIdv() );
            dispatch(doInitiateIdv() );
            break;
          }
        }
        break;
      default:
        break;
      }
    }
    return Promise.resolve();
  };
}

export function doInputTempCode() {
  return { type: types.INPUT_TEMPCODE, };
}

export function captureAvailableModalities(authenticationState) {
  return function(dispatch, getState) {
    const {
      ModalOutOfBandAuthState,
      ModalAuthState,
      ModalTokenAuthState,
      ModalPasswordAuthState,
      ModalFaceAuthState,
      ModalTokenAuthStateTypeModalityAuthAttempted,
      ModalIdAuthStateTypeModalityAuthAttempted,
      ModalPinAuthState,
      ModalPinAuthStateTypeModalityAuthAttempted,
      ModalOutOfBandAuthStateTypeModalityAuthAttempted,
      ModalPasswordAuthStateTypeModalityAuthAttempted,
      ModalFaceAuthStateTypeModalityAuthAttempted,
      ModalEmailAuthState,
      ModalEmailAuthStateTypeModalityAuthAttempted,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeModalityAuthAttempted,
    } = ChooseModalityProtocols;

    const {
      modalities, temporaryCodeAvailable, temporaryCodeAllowed,
    } = authenticationState;
    const availableModalities = [];
    modalities.optionalIdTokenAuthenticationState &&
    !ModalTokenAuthState.isType(modalities.optionalIdTokenAuthenticationState, ModalTokenAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('otp');
    modalities.optionalImprivataIdAuthenticationState &&
    !ModalAuthState.isType(modalities.optionalImprivataIdAuthenticationState, ModalIdAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('iid');
    modalities.optionalImprivataPinAuthenticationState &&
    !ModalPinAuthState.isType(modalities.optionalImprivataPinAuthenticationState, ModalPinAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('pin');
    modalities.optionalEmailOtpAuthenticationState &&
    !ModalEmailAuthState.isType(modalities.optionalEmailOtpAuthenticationState, ModalEmailAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('email');
    modalities.optionalOutOfBandAuthenticationState &&
    !ModalOutOfBandAuthState.isType(modalities.optionalOutOfBandAuthenticationState, ModalOutOfBandAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('sms');
    modalities.optionalPasswordAuthenticationState &&
    !ModalPasswordAuthState.isType(modalities.optionalPasswordAuthenticationState, ModalPasswordAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('password');
    modalities.optionalFaceAuthenticationState &&
    getState().login.isCameraPresent !== false &&
    !ModalFaceAuthState.isType(modalities.optionalFaceAuthenticationState, ModalFaceAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('face');
    modalities.optionalIdvAuthenticationState &&
    !ModalIdvAuthState.isType(modalities.optionalIdvAuthenticationState, ModalIdvAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('idv');
    temporaryCodeAllowed && temporaryCodeAvailable &&
    availableModalities.push('tempcode');

    dispatch(setAvailableModalities(availableModalities) );
  };
}

export function captureAuthenticatedModalities(authenticationState) {
  return function(dispatch) {
    const {
      ModalOutOfBandAuthState,
      ModalAuthState,
      ModalTokenAuthState,
      ModalPasswordAuthState,
      ModalFaceAuthState,
      ModalTokenAuthStateTypeModalityAuthAttempted,
      ModalIdAuthStateTypeModalityAuthAttempted,
      ModalPinAuthState,
      ModalPinAuthStateTypeModalityAuthAttempted,
      ModalOutOfBandAuthStateTypeModalityAuthAttempted,
      ModalPasswordAuthStateTypeModalityAuthAttempted,
      ModalFaceAuthStateTypeModalityAuthAttempted,
      ModalEmailAuthState,
      ModalEmailAuthStateTypeModalityAuthAttempted,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeModalityAuthAttempted,
    } = ChooseModalityProtocols;

    const { modalities, } = authenticationState;
    const authenticatedModalities = [];
    modalities.optionalIdTokenAuthenticationState &&
    ModalTokenAuthState.isType(modalities.optionalIdTokenAuthenticationState, ModalTokenAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('otp');
    modalities.optionalImprivataIdAuthenticationState &&
    ModalAuthState.isType(modalities.optionalImprivataIdAuthenticationState, ModalIdAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('iid');
    modalities.optionalImprivataPinAuthenticationState &&
    ModalPinAuthState.isType(modalities.optionalImprivataPinAuthenticationState, ModalPinAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('pin');
    modalities.optionalEmailOtpAuthenticationState &&
    ModalEmailAuthState.isType(modalities.optionalEmailOtpAuthenticationState, ModalEmailAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('email');
    modalities.optionalOutOfBandAuthenticationState &&
    ModalOutOfBandAuthState.isType(modalities.optionalOutOfBandAuthenticationState, ModalOutOfBandAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('sms');
    modalities.optionalPasswordAuthenticationState &&
    ModalPasswordAuthState.isType(modalities.optionalPasswordAuthenticationState, ModalPasswordAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('password');
    modalities.optionalFaceAuthenticationState &&
    ModalFaceAuthState.isType(modalities.optionalFaceAuthenticationState, ModalFaceAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('face');
    modalities.optionalIdvAuthenticationState &&
    ModalIdvAuthState.isType(modalities.optionalIdvAuthenticationState, ModalIdvAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('idv');
    dispatch(setAuthenticatedModalities(authenticatedModalities) );
  };
}

function isAnotherEnrollmentModalityAvailable(authState) {
  const { optionalOutOfBandEnrollmentState, optionalImprivataIdEnrollmentState, } = authState.modalities;

  const {
    ModalImprivataId,
    ModalOutOfBandEnrollState,
    ModalEnrollmentState,
    ModalOutOfBandEnrollStateTypeEnrollNotAttempted,
    ModalIdEnrollmentStateTypeModalityEnrollNotAttempted,
    ModalIdOutOfBand,
  } = ChooseModalityProtocols;

  switch (authState.currentModality) {
  case ModalImprivataId.asString:
    return Boolean(optionalOutOfBandEnrollmentState &&
        ModalOutOfBandEnrollState.isType(optionalOutOfBandEnrollmentState, ModalOutOfBandEnrollStateTypeEnrollNotAttempted) );
  case ModalIdOutOfBand.asString:
    // falls through
  default:
    return Boolean(optionalImprivataIdEnrollmentState &&
        ModalEnrollmentState.isType(optionalImprivataIdEnrollmentState, ModalIdEnrollmentStateTypeModalityEnrollNotAttempted) );
  }
}

export function doInputIIDEnroll(canSkipEnrollment, canChangeEnrollmentModality) {
  return {
    type: types.INPUT_IMPRIVATA_ID_ENROLL,
    canSkipEnrollment,
    canChangeEnrollmentModality,
  };
}

export function doInputSmsEnroll(canSkipEnrollment, canChangeEnrollmentModality) {
  return {
    type: types.INPUT_SMS_ENROLL,
    canSkipEnrollment,
    canChangeEnrollmentModality,
  };
}

export function doInputSms(lastFourDigits) {
  return {
    lastFourDigits,
    type: types.INPUT_SMS,
  };
}

export function doInputImprivataIdManual(deviceList = []) {
  return {
    deviceList,
    type: types.INPUT_IMPRIVATA_ID_MANUAL,
  };
}

export function doInputOtp(challengeText) {
  return {
    type: types.INPUT_OTP,
    challengeText,
  };
}

export function doInputEmail() {
  return { type: types.INPUT_EMAIL, };
}

export function doStartChangePassword() {
  return { type: types.START_CHANGE_PASSWORD, };
}

export function doInputPassword() {
  return { type: types.INPUT_PASSWORD, };
}

export function doInputPin() {
  return { type: types.INPUT_PIN, };
}

export function doIcpFaceVerification(icpDomainSuffix, icpTenantId) {
  return {
    type: types.INIT_FACE,
    icpDomainSuffix,
    icpTenantId,
  };
}

export function setAvailableModalities(availableModalities) {
  return {
    availableModalities,
    type: types.SET_AVAILABLE_MODALITIES,
  };
}

export function setAuthenticatedModalities(authenticatedModalities) {
  return {
    authenticatedModalities,
    type: types.SET_AUTHENTICATED_MODALITIES,
  };
}

export function setChooseModality(moreOptionsChooseModality) {
  return {
    type: types.SET_IS_FROM_MORE_OPTIONS_LINK,
    moreOptionsChooseModality,
  };
}

export function removeFaceModality() {
  return { type: types.REMOVE_FACE_MODALITY, };
}

export const NoCameraDecision = {
  NONE: 'none',
  LOGOUT: 'logout',
  CHOOSE_MODALITY: 'choose-modality',
  FALLBACK: 'fallback',
};

/**
 * Picks the modality to fall back to when Face cannot be used, ignoring the
 * face and tempcode entries and preferring the highest-priority modality.
 * @param {Array} availableModalities
 * @returns {{type: string, targetModality?: string}}
 */
function getFallbackModalityDecision(availableModalities) {
  const remaining = availableModalities
    .filter(m => m !== 'face' && m !== 'tempcode')
    .sort( (a, b) => getModalityOrder(a) - getModalityOrder(b) );
  if (remaining.length === 0) {
    return { type: NoCameraDecision.LOGOUT, };
  }
  const targetModality = remaining[0];
  if (getModalityId(targetModality) === null) {
    return { type: NoCameraDecision.CHOOSE_MODALITY, };
  }
  return {
    type: NoCameraDecision.FALLBACK,
    targetModality,
  };
}

/**
 * Returns the next modality to fall back to when Face is not available.
 * @param {Array} availableModalities
 * @returns {{type: string, targetModality?: string}}
 */
export function getNoCameraOnDeviceDecision(availableModalities = []) {
  if (!availableModalities.includes('face') ) {
    return { type: NoCameraDecision.NONE, };
  }
  return getFallbackModalityDecision(availableModalities);
}

/**
 * Routes the user based on a fallback decision: switch to another modality
 * (initiating it on the server), let the user choose, or log out.
 */
function dispatchFallbackDecision(decision) {
  return function(dispatch, getState) {
    switch (decision.type) {
    case NoCameraDecision.LOGOUT: {
      const { GetMsgWorkflowNotAllowed, GetMsgModalityNotAllowed, } = GetMessageProtocols;
      const { isEpcsWorkflow, optionalWorkflowName, } = getState().login;
      const error = isEpcsWorkflow || optionalWorkflowName === SECONDFACTORONLY_WORKFLOW
        ? GetMsgWorkflowNotAllowed.asString
        : GetMsgModalityNotAllowed.asString;
      // send empty verification code to fail authentication flow and audit failure in EAM server.
      dispatch(doVerifyIcpFace('', doLoginFailure(error) ) );
      break;
    }
    case NoCameraDecision.CHOOSE_MODALITY:
      dispatch(setChooseModality(true) );
      dispatch(push('/choosemodality') );
      break;
    case NoCameraDecision.FALLBACK:
      // Switch through the appliance so modalities that require server-side
      // initiation (e.g. sms, iid) are started correctly.
      dispatch(doChangeModality('face', decision.targetModality) );
      break;
    default:
      break;
    }
  };
}

/**
 * Handles the case where the user's device does not have a camera.
 * This function will remove the face modality from the available modalities,
 * and then redirect the user to the appropriate modality based on the remaining
 * available modalities.
 */
export function handleNoCameraOnDevice(switchToAnotherModality) {
  return function(dispatch, getState) {
    if (switchToAnotherModality) {
      const before = getState().login.availableModalities || [];
      const decision = getNoCameraOnDeviceDecision(before);
      switch (decision.type) {
      case NoCameraDecision.NONE:
        break;
      default:
        dispatch(removeFaceModality() );
        dispatch(dispatchFallbackDecision(decision) );
        break;
      }
    }
    else {
      dispatch(removeFaceModality() );
    }
  };
}

function isStrongFactor(modalityId) {
  const {
    ModalIdOutOfBand,
    ModalImprivataId,
    ModalIdToken,
    ModalEmailOtp,
  } = ChooseModalityProtocols;

  console.log("" & modalityId); // eslint-disable-line

  const strongFactors = [
    ModalImprivataId.asString,
    ModalIdOutOfBand.asString,
    ModalIdToken.asString,
    ModalEmailOtp.asString,
  ];

  return strongFactors.includes(modalityId);
}

export function doChangeEnrollModality(modality) {
  return function(dispatch, getState) {
    const { ModalEnrollModalityChange, } = ChooseModalityProtocols;
    const { authClient, oneSignSessionId, } = getState().login;
    const modalityId = getModalityId(modality);
    dispatch(startLoading() );
    const changeModality = new ModalEnrollModalityChange(oneSignSessionId, modalityId.asString);
    return authClient.sendRequest(changeModality).then(response => {
      const serverState = response.message;
      dispatch(setServerState(serverState) );
      if (serverState.errorCode) {
        dispatch(doLogout() );
        dispatch(doSecondFactorFailure(serverState.errorCode) );
      }
      else {
        dispatch(decideNextStep(serverState, false) );
      }
    });
  };
}

export function doChangeModality(fromModality, toModality) {
  return function(dispatch, getState) {
    const { ModalAuthChangeModality, ModalResponseAuthErrorContinued, } = ChooseModalityProtocols;
    const {
      serverState, authClient, oneSignSessionId, isDeviceManagementWorkflow,
    } = getState().login;
    dispatch(startLoading() );
    if (fromModality === 'tempcode') {
      dispatch(setTempCodeToManual() );
    }
    // HT-2168 This should be addressed in an appliance change in the future ////////////////
    if (fromModality === 'sms' && toModality === 'sms') {
      dispatch(doResendSms() );
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    if (fromModality === 'otp' && toModality === 'otp') {
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    if (fromModality === 'face' && toModality === 'face') {
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    // ///////////////////////////////////////////////////////////////////////////////////////
    if (toModality === 'tempcode') {
      dispatch(chooseModality(serverState, !isDeviceManagementWorkflow, true) );
      return Promise.resolve();
    }
    else {
      const modalityId = getModalityId(toModality);
      const changeModality = new ModalAuthChangeModality(oneSignSessionId, modalityId.asString);
      return authClient.sendRequest(changeModality).then(response => {
        const serverState = response.message;

        dispatch(setServerState(serverState) );
        if (serverState.errorCode && serverState.responseType !== ModalResponseAuthErrorContinued) {
          dispatch(doLogout() );
          dispatch(doSecondFactorFailure(serverState.errorCode) );
        }
        else {
          dispatch(decideNextStep(serverState, false) );
        }
      });
    }
  };
}

function getModalityId(modalityString) {
  const {
    ModalIdOutOfBand,
    ModalImprivataId,
    ModalIdToken,
    ModalIdPassword,
    ModalEmailOtp,
    ModalImprivataPin,
    ModalFace,
    ModalIdIdv,
  } = ChooseModalityProtocols;

  switch (modalityString) {
  case 'iid':
    return ModalImprivataId;
  case 'sms':
    return ModalIdOutOfBand;
  case 'otp':
    return ModalIdToken;
  case 'email':
    return ModalEmailOtp;
  case 'password':
    return ModalIdPassword;
  case 'pin':
    return ModalImprivataPin;
  case 'face':
    return ModalFace;
  case 'idv':
    return ModalIdIdv;
    // tests ! returning null will break the code at line 314
  default:
    return null;
  }
}
